export const itemVariant = {
  md: 'md',
  lg: 'lg',
  xlg: 'xlg',
} as const

export type ItemVariants = typeof itemVariant[keyof typeof itemVariant]
